import React from 'react'
import { Link } from 'react-router-dom'
import { useAuthContext } from '@/lib/auth-context'

export default function LockerRoomApp() {
  const { profile } = useAuthContext() as any
  const role = profile?.role ?? 'prospect'
  const toolsPath = role === 'coach' ? '/portal/locker/tools' : '/portal/prospect/tools'

  return (
    <section className="space-y-4">
      <div className="rounded-2xl border border-stone-200 bg-white/80 p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-stone-900">Highlight Generator</h2>
        <p className="mt-1 text-sm text-stone-600">
          Turn stats, practice notes, and coach feedback into a highlight story you can share with family, coaches, or recruiters.
        </p>
        <div className="mt-4">
          <Link
            to={toolsPath}
            className="rounded-full bg-stone-900 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-stone-800"
          >
            Open AI Tools
          </Link>
        </div>
      </div>
    </section>
  )
}
